import React from 'react';
import { Form, Formik } from 'formik';
import { Grid, SideSheet } from 'ui-toolkit';
import { IThirdPartyContactData } from '../../../../types/contacts/IThirdPartyContact';
import { FormStatusWrapper } from '../../../shared/FormStatusWrapper/FormStatusWrapper';
import { thirdPartyContactsFormValidation } from '../../../../validation/order/ThirdPartyContactsFormValidation';
import { ThirdPartyContactForm } from './ThirdPartyContactForm';
import { SideSheetFormFooter } from '../../../shared/SideSheetFormFooter';
import { IAddContactFormProps } from '../interfaces/IAddContactFormProps';
import {
  eContactEnvironment,
  eContactType,
  getContactDuplicationMessage,
} from '../../../../utilities/contact/duplicationErrorMessage';

export const AddThirdPartyContactForm: React.FC<IAddContactFormProps> = ({
  onSubmit,
  onCancel,
  addFetchError,
  addFetchStatus,
}) => {
  const initialValues: Partial<IThirdPartyContactData> = {};
  return (
    <Formik
      initialValues={initialValues}
      validateOnMount={true}
      validationSchema={thirdPartyContactsFormValidation}
      onSubmit={onSubmit}
      onReset={onCancel}
    >
      <Form>
        <SideSheet
          title={'New Contact'}
          onClose={onCancel}
          footer={<SideSheetFormFooter onCancel={onCancel} saveButtonText={'Save and Add'} />}
        >
          <Grid>
            <FormStatusWrapper
              fetching={addFetchStatus.fetching}
              fetchedSuccess={addFetchStatus.success}
              fetchError={addFetchError}
              successMessage={'Contact Added!'}
              duplicateMessage={getContactDuplicationMessage(eContactType.ThirdParty, eContactEnvironment.Order)}
            />
            <ThirdPartyContactForm />
          </Grid>
        </SideSheet>
      </Form>
    </Formik>
  );
};
